import ComponentRenderer from '@components/cms-components/component-renderer';
import type { ReactElement } from 'react';
import React from 'react';
import type { BodyContent } from 'types/components/body-content';
import type SiteContext from 'types/site-context';

export interface BodyContentProps {
  readonly body: BodyContent[];
  readonly context: SiteContext;
}

function BodyContentRenderer({
  context,
  body,
}: BodyContentProps): ReactElement {
  return (
    <>
      {body.map((bodyContent, index) => (
        <ComponentRenderer
          context={context}
          key={
            typeof bodyContent === 'object' && '_key' in bodyContent
              ? bodyContent._key
              : typeof bodyContent === 'string'
              ? bodyContent
              : index
          }
          root
        >
          {bodyContent}
        </ComponentRenderer>
      ))}
    </>
  );
}

export default BodyContentRenderer;
